import utransferV2API from "../utransferV2";

export const getBusinessUnityReportData = async (params) => {
  const response = await utransferV2API.get(`/reports/business-unit`, {
    params,
  });

  return response.data;
};
